(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kpr-b2b"] && !Shopify.designMode) return;
  try {
    

(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-kpr-business-intake]').forEach((root) => {
      if (root.dataset.kprFormReady) return;
      const form = root.querySelector('form');
      if (!form) return;
      const inquiry = root.querySelector('[data-kpr-inquiry-select]');
      const values = { workforce: 'Workforce purchasing', volume: 'Volume order', distribution: 'Wholesale / distributor', distributor: 'Wholesale / distributor', oem: 'Custom / OEM' };
      const requested = values[new URLSearchParams(window.location.search).get('inquiry')];
      if (inquiry && !inquiry.value && requested) inquiry.value = requested;
      const steps = [...form.querySelectorAll('fieldset')];
      const progress = root.querySelector('[data-kpr-inquiry-progress]');
      const navigation = root.querySelector('[data-kpr-inquiry-navigation]');
      const back = root.querySelector('[data-kpr-inquiry-back]');
      const next = root.querySelector('[data-kpr-inquiry-next]');
      const submit = root.querySelector('[data-kpr-inquiry-submit]');
      const status = root.querySelector('[data-kpr-inquiry-status]');
      if (steps.length !== 3 || !progress || !navigation || !back || !next || !submit || !status) return;
      const feedback = root.querySelector('[data-kpr-inquiry-errors], [data-kpr-inquiry-success]');
      if (feedback) {
        root.dataset.kprFormReady = 'feedback';
        feedback.focus();
        return;
      }
      let current = 0;
      const labels = ['Contact and buying path', 'Workforce and destination', 'Product and program requirements'];
      const show = (index, focus = false) => {
        current = index;
        steps.forEach((step, number) => { step.hidden = number !== index; });
        [...progress.children].forEach((item, number) => {
          if (number === index) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
          item.classList.toggle('is-complete', number < index);
        });
        back.hidden = index === 0;
        next.hidden = index === steps.length - 1;
        submit.hidden = index !== steps.length - 1;
        next.textContent = index === 0 ? 'Continue to destination →' : 'Continue to requirements →';
        status.textContent = 'Step ' + (index + 1) + ' of 3 · ' + labels[index];
        if (focus) {
          const legend = steps[index].querySelector('legend');
          legend.tabIndex = -1;
          legend.focus({ preventScroll: true });
          form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      };
      const firstInvalid = (scope) => [...scope.querySelectorAll('input,select,textarea')].find((field) => field.willValidate && !field.validity.valid);
      const revealInvalid = (field) => {
        const index = steps.findIndex((step) => step.contains(field));
        if (index >= 0) show(index);
        field.setAttribute('aria-invalid', 'true');
        field.focus();
        field.reportValidity();
      };
      const advance = () => {
        const invalid = firstInvalid(steps[current]);
        if (invalid) revealInvalid(invalid);
        else show(Math.min(current + 1, steps.length - 1), true);
      };
      back.addEventListener('click', () => show(Math.max(current - 1, 0), true));
      next.addEventListener('click', advance);
      form.addEventListener('input', (event) => {
        if (event.target.validity && event.target.validity.valid) event.target.removeAttribute('aria-invalid');
      });
      form.addEventListener('change', (event) => {
        if (event.target.validity && event.target.validity.valid) event.target.removeAttribute('aria-invalid');
      });
      form.addEventListener('submit', (event) => {
        if (current < steps.length - 1) { event.preventDefault(); advance(); return; }
        const invalid = firstInvalid(form);
        if (invalid) { event.preventDefault(); revealInvalid(invalid); }
      });
      root.addEventListener('kpr:inquiry-start', () => {
        show(0);
        const select = root.querySelector('[data-kpr-inquiry-select]');
        if (select) select.focus({ preventScroll: true });
      });
      form.noValidate = true;
      navigation.hidden = false;
      progress.hidden = false;
      show(0);
      root.dataset.kprFormReady = 'true';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpr-cinematic-business"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-kpr-business-cinema]').forEach((root) => {
      if (root.dataset.kprReady) return;
      const setupTabs = (tabSelector, panelSelector, listSelector, getKey) => {
        const tabs = [...root.querySelectorAll(tabSelector)];
        const panels = [...root.querySelectorAll(panelSelector)];
        const list = root.querySelector(listSelector);
        if (!tabs.length || !list || tabs.length !== panels.length) return null;
        const activate = (selected, focus = false) => {
          tabs.forEach((tab, index) => {
            const active = index === selected;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            panels[index].hidden = !active;
          });
          if (focus) tabs[selected].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => { event.preventDefault(); activate(index); });
          tab.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else if (event.key !== ' ') return;
            event.preventDefault();
            activate(next, true);
          });
          tab.setAttribute('role', 'tab');
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].tabIndex = 0;
        });
        list.setAttribute('role', 'tablist');
        if (list.classList.contains('kpr-business-cinema__process-tabs')) {
          const layout = window.matchMedia('(max-width: 680px)');
          const updateOrientation = () => list.setAttribute('aria-orientation', layout.matches ? 'horizontal' : 'vertical');
          updateOrientation();
          layout.addEventListener('change', updateOrientation);
          root.addEventListener('shopify:section:unload', () => layout.removeEventListener('change', updateOrientation), { once: true });
        }
        const fromHash = panels.findIndex((panel) => '#' + panel.id === window.location.hash);
        const inquiry = new URLSearchParams(window.location.search).get('inquiry');
        const normalized = { volume: 'workforce', distributor: 'distribution' }[inquiry] || inquiry;
        const fromInquiry = getKey ? tabs.findIndex((tab) => getKey(tab) === normalized) : -1;
        activate(fromHash >= 0 ? fromHash : fromInquiry >= 0 ? fromInquiry : 0);
        return { tabs, activate };
      };
      const routes = setupTabs('[data-kpr-business-route]', '[data-kpr-business-route-panel]', '.kpr-business-cinema__route-grid', (tab) => tab.dataset.kprInquiry);
      setupTabs('[data-kpr-process-tab]', '[data-kpr-process-panel]', '.kpr-business-cinema__process-tabs');
      root.addEventListener('shopify:block:select', (event) => {
        if (!routes) return;
        const index = routes.tabs.findIndex((tab) => tab.dataset.kprBusinessRoute === event.detail.blockId);
        if (index >= 0) routes.activate(index);
      });
      root.querySelectorAll('[data-kpr-inquiry-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const destination = new URL(link.href, window.location.href);
          if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.hash !== '#kpr-business') return;
          const target = document.querySelector('[data-kpr-business-intake]');
          const select = target && target.querySelector('[data-kpr-inquiry-select]');
          const values = { workforce: 'Workforce purchasing', distribution: 'Wholesale / distributor', oem: 'Custom / OEM' };
          const value = values[link.dataset.kprInquiryLink];
          if (!select || !value || target.dataset.kprFormReady !== 'true') return;
          event.preventDefault();
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          target.dispatchEvent(new CustomEvent('kpr:inquiry-start'));
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
      root.classList.add('is-enhanced');
      root.dataset.kprReady = 'true';
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        }), { threshold: 0.12 });
        root.querySelectorAll('[data-kpr-business-reveal]').forEach((item) => observer.observe(item));
        root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpr-cinematic-industries"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('kpr-industry-cinema')) return;
  customElements.define('kpr-industry-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-kpr-industry-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-kpr-industry-panel]'));
      this.shifts = Array.from(this.querySelectorAll('[data-kpr-industry-shift]'));
      const tablist = this.querySelector('[data-kpr-industry-tabs]');
      if (tablist && this.tabs.length && this.tabs.length === this.panels.length) {
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.activate(index);
          }, options);
          tab.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') next = index;
            if (next === undefined) return;
            event.preventDefault();
            this.activate(next);
            this.tabs[next].focus({ preventScroll: true });
          }, options);
        });
        this.openHashPanel(true);
        window.addEventListener('hashchange', () => this.openHashPanel(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.kprIndustryTab === event.detail?.blockId);
          if (index >= 0) this.activate(index);
        }, options);
      }
      const items = Array.from(this.querySelectorAll('[data-kpr-industry-reveal]'));
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const showAll = () => {
        if (this.observer) this.observer.disconnect();
        items.forEach((item) => item.classList.remove('is-reveal-pending'));
      };
      if ('IntersectionObserver' in window && !motion.matches && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('is-reveal-pending');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        items.forEach((item) => {
          if (item.getBoundingClientRect().top > window.innerHeight) {
            item.classList.add('is-reveal-pending');
            this.observer.observe(item);
          }
        });
      }
      motion.addEventListener('change', showAll, options);
    }
    activate(index) {
      this.tabs.forEach((tab, current) => {
        const active = current === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[current].hidden = !active;
        this.panels[current].classList.toggle('is-active', active);
        if (this.shifts[current]) this.shifts[current].hidden = !active;
      });
    }
    openHashPanel(useDefault = false) {
      const index = this.panels.findIndex((panel) => {
        const legacy = panel.querySelector('[data-kpr-industry-legacy-anchor]');
        return '#' + panel.id === window.location.hash || (legacy && '#' + legacy.id === window.location.hash);
      });
      if (index >= 0 || useDefault) this.activate(index >= 0 ? index : 0);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.querySelectorAll('.is-reveal-pending').forEach((item) => item.classList.remove('is-reveal-pending'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpr-cinematic-protection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kpr-protection-cinema')) {
  customElements.define('kpr-protection-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const tabs = [...this.querySelectorAll('[data-kpr-tab]')];
      const rails = [...this.querySelectorAll('[data-kpr-rail]')];
      const panels = [...this.querySelectorAll('[data-kpr-panel]')];
      if (!tabs.length || !panels.length) return;
      this.querySelector('.kpr-cinema__tabs').setAttribute('role', 'tablist');
      tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      const activate = (id, focus = false) => {
        if (!panels.some(panel => panel.dataset.kprPanel === id)) return;
        tabs.forEach(tab => {
          const active = tab.dataset.kprTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus({preventScroll:true});
        });
        rails.forEach(rail => {
          const active = rail.dataset.kprRail === id;
          rail.classList.toggle('is-active', active);
          rail.setAttribute('aria-current', String(active));
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.kprPanel !== id;
          panel.classList.toggle('is-active', !panel.hidden);
        });
      };
      const fromHash = () => {
        const panel = panels.find(item => '#'+item.id === location.hash);
        if (panel) activate(panel.dataset.kprPanel);
      };
      activate(tabs[0].dataset.kprTab);
      fromHash();
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); activate(tab.dataset.kprTab); }, options);
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') { event.preventDefault(); activate(tab.dataset.kprTab); }
          if (next !== undefined) { event.preventDefault(); activate(tabs[next].dataset.kprTab, true); tabs[next].scrollIntoView({block:'nearest',inline:'nearest'}); }
        }, options);
      });
      rails.forEach(rail => rail.addEventListener('click', event => {
        event.preventDefault();
        activate(rail.dataset.kprRail);
        const panel = panels.find(item => item.dataset.kprPanel === rail.dataset.kprRail);
        panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        panel.focus({preventScroll:true});
      }, options));
      window.addEventListener('hashchange', fromHash, options);
      this.addEventListener('shopify:block:select', event => {
        if (event.detail?.blockId) activate(event.detail.blockId);
      }, options);
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if(entry.isIntersecting){entry.target.classList.add('is-visible');this.observer.unobserve(entry.target);}
        }), {threshold:.12});
        this.querySelectorAll('[data-kpr-reveal]').forEach(item => this.observer.observe(item));
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpr-help-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const compactNavigation = window.matchMedia('(max-width: 900px)');
    const syncNavigation = () => {
      document.querySelectorAll('[data-kpr-help-navigation]').forEach((navigation) => {
        navigation.open = !compactNavigation.matches;
        navigation.querySelector('summary').tabIndex = compactNavigation.matches ? 0 : -1;
      });
    };
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !target.closest('[data-kpr-help]')) return;
      if (target.matches('details')) target.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    const initialize = () => {
      syncNavigation();
      revealHash();
      const feedback = document.querySelector('[data-kpr-help-feedback]');
      if (feedback) {
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('[data-kpr-help-navigation] > summary');
      if (summary && !compactNavigation.matches) event.preventDefault();
      const link = event.target.closest('[data-kpr-help] a[href]');
      if (!link || link.origin !== window.location.origin || link.pathname !== window.location.pathname || link.search !== window.location.search) return;
      let id;
      try { id = decodeURIComponent(link.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (target && target.closest('[data-kpr-help]') && target.matches('details')) target.open = true;
    });
    window.addEventListener('hashchange', revealHash);
    compactNavigation.addEventListener('change', syncNavigation);
    document.addEventListener('shopify:section:load', initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
